<template>
<div id="Vue"  style="background:#eceaea;">

<el-row id="customData" style="margin-top:20px;  padding:10px; background: #fff;" justify="start" v-show="customShow"  >
  <el-row style="padding-bottom:8px"> 选择捐赠金额</el-row>
  <el-col :span="4" @click.native="changeItem('10')" > 
    <el-card id="custom10" >
       
      <div style="padding: 2px;">
        <span  style="text-align:center"><h3>10元</h3></span>
        </br>
		<span   style="text-align:center;font-size:12px;color:#909399"> </span>
      </div>
    </el-card>  
  </el-col> 
  <el-col :span="4" :offset="1" @click.native="changeItem('20')"  >
    <el-card id="custom20" >
      <div style="padding: 2px;">
        <span  style="text-align:center"><h3>20元</h3></span>
        </br>
		<span   style="text-align:center;font-size:12px;color:#909399"> </span>
 
      </div>
    </el-card>
  </el-col>
  <el-col :span="4" :offset="1" @click.native="changeItem('50')"  >
    <el-card id="custom50" >
      <div style="padding: 2px;">
        <span  style="text-align:center"><h3>50元</h3></span>
        </br>
		<span   style="text-align:center;font-size:12px;color:#909399"> </span>
 
      </div>
    </el-card>
  </el-col>
  <el-col :span="4" :offset="1" @click.native="changeItem('100')"  >
    <el-card id="custom100" >
      <div style="padding: 2px;">
        <span  style="text-align:center"><h3>100元</h3></span>
        </br>
		<span   style="text-align:center;font-size:12px;color:#909399"> </span>
 
      </div>
    </el-card>
  </el-col>  
</el-row> 

 
<el-row id="payment" style=" padding:10px; background: #fff;" justify="start"  >
  <el-row style="padding-bottom:8px"> 支付方式</el-row>
  <el-col :span="2" @click.native="changeItem('paymentAli')" v-show="false" > 
    <div><img  id="paymentAli" src="/static/image/alipay.jpg" alt="103*31"/></div>
  </el-col> 
  <el-col :span="2" :offset="1" @click.native="changeItem('paymentWx')"  >
     <div><img  id="paymentWx" src="/static/image/weixinpay.png" alt="103*31"/></div>
  </el-col>
</el-row> 

  <el-row style=" margin-top:20px; background: #fff;">
              <div style="float:right;margin-top:20px;margin-right:100px">
                <span style="">捐赠：</span>
				<span id="amount" style="width:200px; padding-bottom:8px; text-align:center;font-size:16px;color:red;">{{amount}} </span><br/><br/>
                <el-button style="margin-bottom:20px;" type="primary" :loading="is_loading" @click="toPay()" >立即支付</el-button>
            </div>
	</el-row>
	
 
	
</div>
</template>
<style>
  .el-col {
    border-radius: 4px;
  }
  .time {
    font-size: 13px;
    color: #999;
  }
  
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }
.box{
            position: relative;
            
            overflow: hidden;
           
            margin: 0px;
            border: 3px solid #4390df;
        }
        
        .box:before{
            position: absolute;
            display: block;
            border-top: 28px solid #4390df;
            border-left: 28px solid transparent;
            right: 0;
            top: 0;
            content: "";
            z-index: 101;
        }
        .box:after{
            position: absolute;
            display: block;
            content: "\e013";            
            top: 0;
            right: 0;
            font-family: Glyphicons Halflings;
            font-size: 10pt;
            font-weight: normal;
            z-index: 102;
            color: #fff;
        }
 
</style>

<script>
  export default {
        name: "payment",
        data () {
		  return{
	    	is_loading: false,
		    userInfo: {},
			login_state: 0,
			customShow : true,
			erpShow: false,
			amount: 0, 
			sk_id: 0,
			sk_name: '', 
			pay_mode: 'ali',
			} 
        },
        methods: {
		  toPay(){
		  //  if (this.pay_mode == 'ali')
			//    this.aliPay();
		//	else
			    this.wxPay();
		  
		  },
		  changeItem(val){ 
              if (val == '10'){  
				$("#custom10").addClass("box");
				$("#custom20").removeClass("box"); 
				$("#custom50").removeClass("box"); 
				$("#custom100").removeClass("box"); 
				this.sk_id = 20;
                this.sk_name = '捐赠';
                this.amount = 10;	 
				}
              if (val == '20'){  
				$("#custom20").addClass("box");
				$("#custom10").removeClass("box"); 
				$("#custom50").removeClass("box"); 
				$("#custom100").removeClass("box"); 
				this.sk_id = 21;
                this.sk_name = '捐赠';
                this.amount = 20;	 
				}
              if (val == '50'){  
				$("#custom50").addClass("box");
				$("#custom20").removeClass("box"); 
				$("#custom10").removeClass("box"); 
				$("#custom100").removeClass("box"); 
				this.sk_id = 22;
                this.sk_name = '捐赠';
                this.amount = 50;	 
				}
              if (val == '100'){  
				$("#custom100").addClass("box");
				$("#custom20").removeClass("box"); 
				$("#custom50").removeClass("box"); 
				$("#custom10").removeClass("box"); 
				this.sk_id = 23;
                this.sk_name = '捐赠';
                this.amount = 100;	 
				}	
              if (val == 'paymentWx'){
                $("#paymentAli").removeClass("box");
				$("#paymentWx").addClass("box");			   
				this.pay_mode = 'wx';
				}					
		  },
		  aliPay(){ 

			 
			  var g_url = 'https://www.myferp.com/admin/user/createOrder';
					let userInfo = localStorage.getItem('userInfo');
					let info1 = JSON.parse(userInfo);
					let id = info1.id;
					this.amount = 0.01;
			  var info = {'user_id':id , 
					'sk_id': this.sk_id,
					'sk_name':  this.sk_name,
					'sk_amount': this.amount,		
					};
			  let that = this;
			  that.is_loading = true;
			  $.ajax({
						 type: "POST",
						 url: g_url,
						 data: info, 
						 dataType: "json",
						 beforeSend: function (request) {
							request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
							},  
						 error: function(XMLHttpRequest, textStatus, errorThrown) {
									alert('请求失败!');
								},
						 success: function(data){
									 console.log(data); 
									 if (data.errno == 0){
									 
										 g_url = '/aliPay'; 
										 let order_sn = data.data.orderInfo.order_sn;
										 let order_name = data.data.orderInfo.sk_name;
										 let order_amount = data.data.orderInfo.sk_amount;
										 localStorage.setItem('orderId', data.data.orderInfo.id );
										 localStorage.setItem('orderAmount', data.data.orderInfo.sk_amount );
										 localStorage.setItem('orderName', data.data.orderInfo.sk_name );
										 $.ajax({
											type: "get",
											url: g_url,
											data: {amount: that.amount, order_sn: order_sn, order_name: order_name, order_amount: order_amount}, 
											dataType: "text",
											error: function(XMLHttpRequest, textStatus, errorThrown) {
														  alert('请求失败!');
														  that.is_loading = false;
													},
											success: function(data){
													console.log(data);
													that.is_loading = false;
													localStorage.setItem('aliPay', data);
													window.location.href= data;
								  
													 }
											});
									 
									 
									 
									 }else{
									   alert(data.errmsg);
									 }
								  }
					 });
			},
		   wxPay(){
			 
			  var g_url = 'https://www.myferp.com/admin/user/createOrder';
					let userInfo = localStorage.getItem('userInfo');
					let info1 = JSON.parse(userInfo);
					let id = info1.id;
			//		this.amount = 0.01;
			  var info = {'user_id':id , 
					'sk_id': this.sk_id,
					'sk_name':  this.sk_name,
					'sk_amount': this.amount,		
					};
			  let that = this;
			  that.is_loading = true;
			  $.ajax({
						 type: "POST",
						 url: g_url,
						 data: info, 
						 dataType: "json",
						 beforeSend: function (request) {
							request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
							},  
						 error: function(XMLHttpRequest, textStatus, errorThrown) {
						         console.log('order fail');
									alert('请求失败!');
								},
						 success: function(data){
									 console.log(data); 
									 if (data.errno == 0){
									 
										 g_url = 'http://139.196.212.46:8800/wxPay'; 
										 let order_sn = data.data.orderInfo.order_sn;
										 let order_name = data.data.orderInfo.sk_name;
										 let order_amount = data.data.orderInfo.sk_amount;
										 localStorage.setItem('orderId', data.data.orderInfo.id );
										 localStorage.setItem('orderAmount', data.data.orderInfo.sk_amount );
										 localStorage.setItem('orderName', data.data.orderInfo.sk_name );
										 $.ajax({
											type: "get",
											url: g_url,
											data: {amount: that.amount, order_sn: order_sn, order_name: order_name, order_amount: order_amount}, 
											dataType: "text",
											error: function(XMLHttpRequest, textStatus, errorThrown) {
														  alert('请求失败!');
														  that.is_loading = false;
													},
											success: function(data){
													console.log('wx response:' + data);
													that.is_loading = false;
													localStorage.setItem('wxPay', data);
													that.$router.push({
					                                    path: '/customs/wxpay',
					                                    params: {
					                                         sometext: ''
					                                         }
				                                        });
								  
													 }
											});
									 
									 
									 
									 }else{
									   alert(data.errmsg);
									 }
								  }
					 });
					 

			},

		},
		mounted(){
		    let userInfo = localStorage.getItem('userInfo'); //判断登录状态
				console.log( 'user:' + typeof userInfo);  
				if (userInfo == '' || userInfo == null || typeof userInfo == undefined ) {
				    this.login_state = 0;
					this.$router.push({name:'login'});
				}else{
				    this.login_state = 1;
				}
		  this.changeItem('10');
		  this.changeItem('paymentWx'); 
		},
		

		}
</script>

 


// WEBPACK FOOTER //
// src/components/customs/donation.vue